<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Stores
	//Svelte hooks
	import { onMount } from 'svelte';
	//Components
	import AnalogCalibration from '../../AddonSettingsG2/AnalogInputSettings/AnalogCalibration.svelte';
	//Design system components
	import { Text } from '@Shelly/shelly-design-system/index';

	export let device, channel;

	let id = real_id(device.id);

	let settings;
	let rangeMap;
	let component = 'input';

	const getSettings = () => {
		const root = readDeviceSettings(id);
		settings = root?.[`${component}:${channel}`];
		settings.id = channel;
		rangeMap = settings?.range_map; //using rangeMap for re-rending analog calibration component
	};

	onMount(() => {
		getSettings();
	});
	$: (getSettings(), channel); //change settings based on channel
</script>

{#key rangeMap}
	<Text styleType="h2" class="mb-s text-left">
		{$format('peripherals_analog_input_calibration', {
			default: 'Analog calibration (range map)',
		})}
	</Text>
	<AnalogCalibration class="mb-m" {device} {settings} />
{/key}
